<template>
    <div class="news" id="news">
        <div class="mobiletopbox hidden-sm-and-up">
            <div class="mobiletopbox_top">
                <div class="navigation">
                    <div class="navigation_location"></div>
                    <div class="navigation_index" @click="goIndex">Home</div>
                    <div class="navigation_img"></div>
                        <div class="navigation_text">Party Building Work</div>
                </div>
            </div>
        </div>
        <div class="news_box section">
            <div class="news_right" v-loading="loading">
                <div class="news_right_top hidden-xs-only">
                    <div class="navigation">
                        <div class="navigation_location"></div>
                        <div class="navigation_text">Location：</div>
                        <div class="navigation_index" @click="goIndex">Home</div>
                        <div class="navigation_img"></div>
                        <div class="navigation_text">Party Building Work</div>
                    </div>
                </div>
                <div class="news_right_bottom">
                    <div class="news_right_bottom_box" v-if="newsList.length>0">
                        <div class="news_right_bottom_item" v-for="(item,index) in newsList" :key="index">
                            <div class="news_right_bottom_item_box">
                                <div class="news_right_bottom_item_left">
                                    <div class="news_right_bottom_item_left_box">
                                        <div class="news_right_bottom_item_left_left">{{item.publishTime?handleTime(1,item.publishTime):''}}</div>
                                        <div class="news_right_bottom_item_left_line"></div>
                                        <div class="news_right_bottom_item_left_right">
                                            <div class="news_right_bottom_item_left_right_top">{{item.publishTime?handleTime(2,item.publishTime):''}}</div>
                                            <div class="news_right_bottom_item_left_right_img">
                                                <img src="../assets/images/common/time.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="news_right_bottom_item_middle">
                                    <div class="news_right_bottom_item_middle_top">{{item.title}}</div>
                                    <div class="news_right_bottom_item_middle_middle">{{item.profile}}</div>
                                </div>
                                <div class="news_right_bottom_item_right">
                                    <div class="news_right_bottom_item_right_img" @click="linkToDetails(item)"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="news_right_bottom_none" v-if="newsList.length == 0">No data available</div>
                    <!-- 分页 -->
                    <el-pagination
                        :current-page="query.current"
                        :page-size="query.pageSize"
                        @current-change="handleCurrentChange"
                        background
                        :total="total"
                        :pager-count="5"
                        layout="prev, pager, next">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { newsList } from '../untils/common-api.js'
export default {
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_URL,
            loading: false,
            typeList: [],
            total: null,
            query: {
                current: this.$route.query.current? Number(this.$route.query.current) : 1,
                pageSize: 8,
                model:3,
                newsType: '',
                lang:2
            },
            newsList: []
        }
    },
    created() {
        this.getNewsList()
    },
    mounted() {
        this.getScrollTop()
    },
    methods:{
        // 获取新闻列表
        async getNewsList() {
            this.loading = true // loading start
            let res = await newsList(this.query)
            this.loading = false // loading end
            if (res.code !== 1) return this.$message('Information retrieval failed. Please try again later')
            this.total = res.data.total
            this.newsList = res.data.records
            setTimeout(() => {
                this.restoreScrollPosition()
            }, 500);
        },
        handleCurrentChange(data) {
            this.query.current = data
            this.getNewsList()
            this.getScroll()
        },
        // 跳转详情
        linkToDetails(item) {
            if(item.link) {
                window.open(item.link, '_blank');
            } else {
                this.$router.push({name: 'specifics_en', params: { name: 'work_en', type: 0, id: item.id,current:this.query.current } })
            }
        },
        goIndex() {
            this.$router.push('/index_en')
        },
        handleTime(num,time) {
            if(time) {
                let year = time.substring(0,4);
                let month = time.substring(5,7);
                let day = time.substring(8,10);
                let timeStr = ''
                if(num==1) {
                   timeStr = day
                } else {
                   timeStr = year+'年'+month+'日'
                }
                return timeStr;
            }
        },
        getScroll() {
            let div = document.getElementById('news');
            if (div) {
                setTimeout(function () {
                    $('html, body').animate({scrollTop: 0}, 600)
                }, 500);
            }
        },
        restoreScrollPosition() {
            const scrollPosition = window.sessionStorage.getItem('scrollPosition');
            if (scrollPosition) {
                // 恢复滚动位置
                $('html, body').animate({scrollTop: scrollPosition}, 100)
                setTimeout(() => {
                    window.sessionStorage.removeItem('scrollPosition'); // 清除存储的滚动位置，防止重复使用
                }, 500);
            }
        },
        getScrollTop() {
            let div = document.getElementById('news');
            if (div) {
                setTimeout(function () {
                    $('html, body').animate({scrollTop: 0}, 0)
                }, 0);
            }
        },
    },
    beforeRouteLeave(to, from, next) {
        if(to.name == "specifics_en") {
            window.sessionStorage.setItem('scrollPosition', window.scrollY);
        }
        next();
    },
}
</script>
<style lang="less" scoped>
.news {
    background-color: #f6f9ff;
    padding: 30px 0 60px 0;
    .news_box {
        .news_right {
            width: 100%;
            .news_right_top {
                margin-bottom: 20px;
            }
            .news_right_bottom {
                background-color: #ffffff;
                padding-bottom: 60px;
                .news_right_bottom_box {
                    margin-bottom: 60px;
                    .news_right_bottom_item {
                        padding: 0 30px;
                        .news_right_bottom_item_box {
                            height: 213px;
                            display: flex;
                            justify-content: space-between;
                            border-bottom: 1px solid #DCDCDC;
                            padding: 55px 0;
                            .news_right_bottom_item_left {
                                width: 180px;
                                .news_right_bottom_item_left_box {
                                    display: flex;
                                    align-items: center;
                                    margin-top: -5px;
                                    .news_right_bottom_item_left_left {
                                        font-size: 36px;
                                        font-weight: bold;
                                        color: #A6A6A6;
                                    }
                                    .news_right_bottom_item_left_line {
                                        height: 32px;
                                        width: 1px;
                                        background-color: #A6A6A6;
                                        margin: 0 12px;
                                    }
                                    .news_right_bottom_item_left_right {
                                        font-size: 14px;
                                        color: #A6A6A6;
                                        .news_right_bottom_item_left_right_img {
                                            width: 12px;
                                            height: 12px;
                                            position: relative;
                                            img {
                                                position: absolute;
                                                top: 0;
                                                left: 0;
                                                width: 12px;
                                                height: 12px;
                                            }
                                        }
                                    }
                                }
                            }
                            .news_right_bottom_item_middle {
                                width: calc(100% - 180px - 100px);
                                margin-right: 60px;
                                .news_right_bottom_item_middle_top {
                                    color: #000000;
                                    font-size: 20px;
                                    font-weight: bold;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 1;
                                    -webkit-box-orient: vertical;
                                    overflow: hidden;
                                    margin-bottom: 15px;
                                }
                                .news_right_bottom_item_middle_middle {
                                    font-size: 16px;
                                    color: #787878;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 2;
                                    -webkit-box-orient: vertical;
                                    overflow: hidden;
                                    line-height: 1.8;
                                }
                            }
                            .news_right_bottom_item_right {
                                width: 100px;
                                display: flex;
                                align-items: center;
                                .news_right_bottom_item_right_img {
                                    cursor: pointer;
                                    width: 44px;
                                    height: 44px;
                                    background: url('../assets/images/common/go.png') no-repeat center center;
                                }
                            }
                        }
                    }
                    .news_right_bottom_item:hover {
                        box-shadow: 0px 0px 14px 0px rgba(29,47,71,0.14); 
                        background: url('../assets/images/common/work_item_bgc.png') no-repeat center center;
                        background-size: 100% 100%;
                        .news_right_bottom_item_box {
                            .news_right_bottom_item_middle {
                                .news_right_bottom_item_middle_top {
                                    color: #0085D0;
                                    text-decoration: underline;
                                    text-underline-offset: 3px;
                                }
                            }
                            .news_right_bottom_item_right {
                                .news_right_bottom_item_right_img {
                                    background: url('../assets/images/common/go_active.png') no-repeat center center;
                                }
                            }
                        }
                    }
                }
                .news_right_bottom_none {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #ffffff;
                    min-height: 200px;
                    font-size: 16px;
                    margin-bottom: 60px;
                }
            }
        }
    }
}
@media (max-width: 768px) {
    .news {
        padding: 0.3rem 0 0.6rem 0;
        .news_box {
            .news_right {
                width: 100%;
                padding-top: 0.2rem;
                .news_right_bottom {
                    padding-bottom: 0.6rem;
                    .news_right_bottom_box {
                        margin-bottom: 0.6rem;
                        .news_right_bottom_item {
                            padding: 0 0.2rem;
                            .news_right_bottom_item_box {
                                height: auto;
                                padding: 0.4rem 0;
                                .news_right_bottom_item_left {
                                    width: 2.3rem;
                                    .news_right_bottom_item_left_box {
                                        margin-top: 0;
                                        .news_right_bottom_item_left_left {
                                            font-size: 0.4rem;
                                        }
                                        .news_right_bottom_item_left_line {
                                            height: 0.4rem;
                                            width: 0.02rem;
                                            margin: 0 0.1rem;
                                        }
                                        .news_right_bottom_item_left_right {
                                            font-size: 0.26rem;
                                            .news_right_bottom_item_left_right_img {
                                                width: 0.24rem;
                                                height: 0.24rem;
                                                img {
                                                    position: absolute;
                                                    top: 0;
                                                    left: 0;
                                                    width: 0.24rem;
                                                    height: 0.24rem;
                                                }
                                            }
                                        }
                                    }
                                }
                                .news_right_bottom_item_middle {
                                    width: calc(100% - 2.3rem - 0.6rem );
                                    margin-right: 0;
                                    .news_right_bottom_item_middle_top {
                                        font-size: .3rem;
                                        margin-bottom: 0.1rem;
                                    }
                                    .news_right_bottom_item_middle_middle {
                                        font-size: 0.28rem;
                                        // display: -webkit-box;
                                        // -webkit-line-clamp: 2;
                                        // -webkit-box-orient: vertical;
                                        // overflow: hidden;
                                        line-height: 1.6;
                                    }
                                }
                                .news_right_bottom_item_right {
                                    width: 0.6rem;
                                    display: flex;
                                    flex-direction: row-reverse;
                                    .news_right_bottom_item_right_img {
                                        width: 0.5rem;
                                        height: 0.5rem;
                                        background-size: 100% 100%;
                                    }
                                }
                            }
                        }
                        .news_right_bottom_item:hover {
                        .news_right_bottom_item_box {
                            .news_right_bottom_item_right {
                                .news_right_bottom_item_right_img {
                                    background-size: 100% 100%;
                                }
                            }
                        }
                    }
                    }
                    .news_right_bottom_none {
                        min-height: 3rem;
                        font-size: 0.3rem;
                        margin-bottom: 0.6rem;
                    }
                }
            }
        }
    }
}

</style>